import e from "./ghl-ui.es1651.js";
function n(r, a) {
  var t = r.__data__;
  return e(a) ? t[typeof a == "string" ? "string" : "hash"] : t.map;
}
export {
  n as default
};
